import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { getStorageData } from "../../../framework/src/Utilities";
import { apiCall } from "../../../components/src/common";
import { handleMomentDateFormat } from "../../cfcashier/src/utils";
import moment from "moment";
import { IFilter } from "../../../components/src/FilterPopover";
import html2pdf from "html2pdf.js";
import { handleDisplayRegion } from "./utils";
import {
  customPermissionApiKey,
  DashboardPermissionStatus,
  checkForDashboardPermissonStatus,
  checkIsFilterApplied,
  getDateRangeForQuery,
} from "../../utilities/src/CustomBlockHelpers";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
export const configJSON = require("./config");

interface SalesData {
  order_count: number | string;
  amount: string | number;
}

interface PurchasedData {
  order_count: number;
  amount: string;
}

interface RedeemedData {
  order_count: number;
  amount: string;
}

interface TotalSalesData {
  total_orders: number;
  total_stores: number;
  total_base_points: number;
  total_bonus_points: number;
  total_vat_points: number;
  total_points: number;
  total_price: number;
  free_wash_quantity: number;
}

interface TotalRedeemedData {
  total_orders: number;
  total_stores: number;
  total_bonus_used: number;
  total_base_used: number;
  total_wallet_balance: number;
  free_wash_amount: number;
  free_wash_pieces: number;
  total_order_amount: number;
}

interface TopSellingProductdata {
  product_name: string;
  total_quantity: number;
  percentage: string;
}

interface StoreWiseData {
  orders_count: number;
  amount: string;
}

interface StoreData {
  store_name: string;
  general_discount: StoreWiseData;
  compensation_credit: StoreWiseData;
  loyalty_credit: StoreWiseData;
}

export interface Props {
  navigation: any;
  id: string;
}

export interface S {
  filters: IFilter[];
  storeId: string;
  groupId: string;
  areaId: string;
  regionId: string;
  advanceSalesData: SalesData;
  advanceSalesPurchasedData: PurchasedData;
  advanceSalesRedeemedData: RedeemedData;
  advanceSalesRedementionData: RedeemedData;
  totalSalesData: TotalSalesData;
  redeemedSummaryData: TotalRedeemedData;
  topSellingProductData: TopSellingProductdata[];
  topRedeemingProductData: TopSellingProductdata[];
  compensationCreditData: PurchasedData;
  storewiseDiscountData: StoreData[];
  filterAnchor: HTMLDivElement | undefined;
  regionName: string;
  storeNames: string;
  groupNames: string;
  isOpenExportModal: boolean;
  permissionStatus: DashboardPermissionStatus | null;
  storeWiseDiscountMetaInfo: {
    storeListPageNo: number;
    storeItemsPerPage: number;
    totalCount: number;
  };
  isAppliedFilter: boolean;
}

interface SS {
  id: any;
}

export default class AdvanceSalesDashboardController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getTotalAdvanceSalesCallId: string = "getTotalAdvanceSalesCallId";
  getTotalPurchasedAdvanceSalesCalId: string =
    "getTotalPurchasedAdvanceSalesCalId";
  getTotalRedeemedAdvanceSalesCalId: string =
    "getTotalRedeemedAdvanceSalesCalId";
  getTotalRedementionAdvanceSalesCalId: string =
    "getTotalRedemtionAdvanceSalesCalId";
  getTotalSalesDetailsCalId: string = "getTotalSalesDetailsCalId";
  getTotalRedeemedCalId: string = "getTotalRedeemedCalId";
  getTopSellingProductsCalId: string = "getTopSellingProductsCalId";
  getTopRedeemingProductsCalId: string = "getTopRedeemingProductsCalId";

  getLoyaltyCreditCallId: string = "getLoyaltyCreditCallId";
  getCompensationCreditCallId: string = "getCompensationCreditCallId";
  getStorewiseDiscountCallId: string = "getStorewiseDiscountCallId";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.BroadcastNavbarDataMessage),
      getName(MessageEnum.LayoutDataMessage),
    ];
    this.state = {
      storewiseDiscountData: [],
      filters: [
        {
          title: "Date",
          value: "today",
          type: "dateselect",
          datevalue: { from: "", to: "" },
          options: [
            {
              label: "Today",
              value: "today",
            },
            {
              label: "Last 7 days",
              value: "last_7_days",
            },
            {
              label: "Last 30 days",
              value: "last_30_days",
            },
            {
              label: "Specific Dates",
              value: "specific",
            },
          ],
        },
      ],
      storeId: "",
      areaId: "",
      groupId: "",
      groupNames: "",
      regionId: "",
      advanceSalesData: {
        order_count: 0,
        amount: "0.00",
      },
      advanceSalesPurchasedData: {
        order_count: 0,
        amount: "0.00",
      },
      advanceSalesRedeemedData: {
        order_count: 0,
        amount: "0.00",
      },
      totalSalesData: {
        total_orders: 0, 
        total_stores: 0, 
        total_base_points: 0, 
        total_bonus_points: 0, 
        total_vat_points: 0, 
        total_points: 0, 
        total_price: 0,
        free_wash_quantity: 0,
      },
      redeemedSummaryData: {
        total_orders: 0, 
        total_stores: 0, 
        total_bonus_used: 0, 
        total_base_used: 0, 
        total_wallet_balance: 0,
        free_wash_pieces: 0,
        free_wash_amount:0,
        total_order_amount: 0, 
      },
      topSellingProductData: [
        {
          product_name: "", 
          total_quantity: 0,
          percentage: "",
        },
      ],

      topRedeemingProductData: [
        {
          product_name: "", 
          total_quantity: 0,
          percentage: "",
        },
      ],

      advanceSalesRedementionData: {
        order_count: 0,
        amount: "0.00",
      },
      compensationCreditData: {
        order_count: 0,
        amount: "0.00",
      },
      filterAnchor: undefined,
      storeNames: "",
      regionName: "",
      isOpenExportModal: false,
      permissionStatus: null,
      storeWiseDiscountMetaInfo: {
        storeListPageNo: 1,
        storeItemsPerPage: 20,
        totalCount: 0,
      },
      isAppliedFilter: false,
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.receiveDataFromLayout(message);
    this.getBroadcastedData(message);
    this.handleResForTotalAdvanceSales(from, message);
    this.handleTotalPurchasedAdvanceSales(message);
    this.handleTotalRedeemedAdvanceSales(message);
    this.handleTotalRedementionAdvanceSales(message);
    this.handleResForCompensationCredit(message);
    this.handleTotalSalesDetails(message);
    this.handleRedeemedSummaryData(message);
    this.handleTopSellingProductsData(message);
    this.handleTopSRedeemingProductsData(message);

    // Customizable Area End
  }

  // Customizable Area Start
  getOverallData = async () => {
    const dateFilterQuery = this.handleDateFilterParam().dateFilterQuery;
    let headers = {
      token: await getStorageData("token"),
      "Content-Type": configJSON.dashboarContentType,
    };
    const { groupId, areaId, storeId } = this.state;
    const groupParam = groupId ? `&group_ids=${groupId}` : "";
    const areaParam = areaId ? `&area_ids=${areaId}` : "";
    const storeParam = storeId ? `&store_ids=${storeId}` : "";
    const newParam = groupParam + areaParam + storeParam;
    const requests = [
      {
        apiCallId: "getTotalAdvanceSalesCallId",
        endPoint: configJSON.getTotalAdvanceSales + "?region_ids=",
      },
      {
        apiCallId: "getTotalPurchasedAdvanceSalesCalId",
        endPoint: configJSON.getTotalPurchasedAdvanceSales + "?region_ids=",
      },
      {
        apiCallId: "getTotalRedeemedAdvanceSalesCalId",
        endPoint: configJSON.getTotalRedeemedAdvanceSales + "?region_ids=",
      },
      {
        apiCallId: "getTotalRedementionAdvanceSalesCalId",
        endPoint: configJSON.getTotalRedemptionAdvanceSales + "?region_ids=",
      },
      {
        apiCallId: "getTotalSalesDetailsCalId",
        endPoint: configJSON.getTotalSalesDetails + "?region_ids=",
      },
      {
        apiCallId: "getTotalRedeemedCalId",
        endPoint: configJSON.getTotalRedeemedData + "?region_ids=",
      },
      {
        apiCallId: "getTopSellingProductsCalId",
        endPoint: configJSON.getTopSellingProductsData + "?region_ids=",
      },
      {
        apiCallId: "getTopRedeemingProductsCalId",
        endPoint: configJSON.getTopRedeemingProductsData + "?region_ids=",
      },
    ] as const;
    requests.forEach((request) => {
      const requestMessage = apiCall({
        httpBody: {},
        header: headers,
        url: `${request.endPoint}${this.state.regionId}${newParam}${dateFilterQuery}`,
        httpMethod: configJSON.dashboarApiMethodType,
      });
      this[request.apiCallId] = requestMessage.messageId;
      this.send(requestMessage);
    });
  };

  handleResForTotalAdvanceSales = async (from: string, message: Message) => {
    if (
      this.getTotalAdvanceSalesCallId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      console.log("responseJsonresponseJson", responseJson);
      if (responseJson.status == 200) {
        this.setState({ advanceSalesData: responseJson.data });
      }
    }
  };

  handleTotalPurchasedAdvanceSales = async (message: Message) => {
    if (
      this.getTotalPurchasedAdvanceSalesCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ advanceSalesPurchasedData: responseJson.data });
      }
    }
  };

  handleTotalRedeemedAdvanceSales = async (message: Message) => {
    if (
      this.getTotalRedeemedAdvanceSalesCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ advanceSalesRedeemedData: responseJson.data });
      }
    }
  };

  handleTotalRedementionAdvanceSales = async (message: Message) => {
    if (
      this.getTotalRedementionAdvanceSalesCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ advanceSalesRedementionData: responseJson.data });
      }
    }
  };

  handleTotalSalesDetails = async (message: Message) => {
    if (
      this.getTotalSalesDetailsCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ totalSalesData: responseJson.data });
      }
    }
  };

  handleRedeemedSummaryData = async (message: Message) => {
    if (
      this.getTotalRedeemedCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ redeemedSummaryData: responseJson.data });
      }
    }
  };

  handleTopSellingProductsData = async (message: Message) => {
    if (
      this.getTopSellingProductsCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ topSellingProductData: responseJson.data });
      }
    }
  };

  handleTopSRedeemingProductsData = async (message: Message) => {
    if (
      this.getTopRedeemingProductsCalId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ topRedeemingProductData: responseJson.data });
      }
    }
  };

  handleResForCompensationCredit = async (message: Message) => {
    if (
      this.getCompensationCreditCallId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson.status == 200) {
        this.setState({ compensationCreditData: responseJson.data });
      }
    }
  };

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };

  getBroadcastedData = (message: Message) => {
    if (message.id === getName(MessageEnum.BroadcastNavbarDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.BroadcastNavbarData)
      );
      if (recievedData.regionMultiId) {
        this.setState(
          {
            areaId: recievedData.areaId,
            storeId: recievedData.storeId,
            groupId: recievedData.groupId,
            groupNames: recievedData.groupNames,
            regionId: recievedData.regionMultiId,
            regionName: handleDisplayRegion(
              recievedData.regionMultiId,
              recievedData.regionNames,
              recievedData.regionSelectAll
            ).textDisplayed,
            storeNames: recievedData.storeNames,
            storewiseDiscountData: [],
            storeWiseDiscountMetaInfo: {
              ...this.state.storeWiseDiscountMetaInfo,
              storeListPageNo: 1,
              totalCount: 0,
            },
          },
          () => {
            this.handleStorageFilter();
          }
        );
      }
    }
  };

  handleExportConfirm = async (methodType: string) => {
    if (methodType === "pdf") {
      const wrapperPrintElement = document.getElementById(
        "print-wrapper"
      ) as HTMLElement;

      await html2pdf(wrapperPrintElement, {
        jsPDF: {
          format: [1440, 1440],
          unit: "px",
        },
        filename: "DiscountCredit-dashboard.pdf",
        margin: 24,
        pagebreak: { mode: ["css"] },
      });
      this.setState({ isOpenExportModal: false });
    }
  };

  handleDateFilterParam = () => {
    const today = moment().format("YYYY-MM-DD");
    let comomStartDate = moment().subtract(6, "days").format("YYYY-MM-DD");
    const dateFilter = this.state.filters.find(
      (item) => item?.title === "Date"
    )?.value;
    let commonEndDate = today;
    let startDate, endDate;
    switch (dateFilter) {
      case "last7":
      case "last_7_days":
        endDate = commonEndDate;
        startDate = comomStartDate;
        break;
      case "today":
        startDate = today;
        endDate = today;
        break;
      case "specific":
        const dateFilter = this.state.filters.find(
          (item) => item?.title === "Date"
        )?.datevalue;
        if (dateFilter?.from && dateFilter?.to) {
          endDate = moment(dateFilter.to).format("YYYY-MM-DD");
          startDate = moment(dateFilter.from).format("YYYY-MM-DD");
        }
        break;
      case "last30":
      case "last_30_days":
        startDate = moment().subtract(29, "days").format("YYYY-MM-DD");
        endDate = today;
        break;
      default:
        startDate = today;
        endDate = commonEndDate;
    }
    const startDateText = startDate
      ? handleMomentDateFormat(startDate, "DD-MM-YYYY")
      : moment().subtract(6, "days").format("DD-MM-YYYY");
    const endDateText = endDate
      ? handleMomentDateFormat(endDate, "DD-MM-YYYY")
      : moment().format("DD-MM-YYYY");

    const dateFilterQuery =
      startDate && endDate
        ? `&date_type=specific_dates${
            getDateRangeForQuery(startDate, endDate).dateRangeQuery
          }`
        : "";

    return { startDateText, dateFilterQuery, endDateText };
  };

  handleFilterOpen = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.setState({ filterAnchor: event.currentTarget });
  };

  handleCloseFilterPopover = () => {
    this.setState({ filterAnchor: undefined });
  };

  handleFilterChangeAccount = (filters: IFilter[]) => {
    if (checkIsFilterApplied(filters)) {
      localStorage.setItem("filter_value", JSON.stringify(filters));
    } else {
      localStorage.removeItem("filter_value");
    }
    this.setState(
      {
        filters,
        storewiseDiscountData: [],
        storeWiseDiscountMetaInfo: {
          ...this.state.storeWiseDiscountMetaInfo,
          storeListPageNo: 1,
          totalCount: 0,
        },
        isAppliedFilter: checkIsFilterApplied(filters),
      },
      () => {
        this.getOverallData();
      }
    );
  };

  handleExportModalStats = () => {
    this.setState({ isOpenExportModal: !this.state.isOpenExportModal });
  };

  handleUserChange = (context: IUserContext) => {
    const apiKey = customPermissionApiKey.dashboardPermission;
    const userData = context.user?.attributes.permission_groups;
    const value = checkForDashboardPermissonStatus(
      apiKey,
      userData as unknown as Array<PermissionGroupArray>
    );
    this.setState({
      permissionStatus: value,
    });
  };

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

  handleStorageFilter = () => {
    const applied_profession_filter = localStorage.getItem("filter_value");
    if (applied_profession_filter) {
      this.setState(
        {
          filters: JSON.parse(applied_profession_filter),
          isAppliedFilter: checkIsFilterApplied(
            JSON.parse(applied_profession_filter)
          ),
        },
        () => {
          this.getOverallData();
        }
      );
    } else {
      this.getOverallData();
    }
  };

  isLoading = () => {
    const {
      advanceSalesData,
      advanceSalesPurchasedData,
      advanceSalesRedeemedData,
      totalSalesData,
      redeemedSummaryData,
      topSellingProductData,
      topRedeemingProductData,
    } = this.state;

    return !!(
      advanceSalesData ||
      advanceSalesPurchasedData ||
      advanceSalesRedeemedData ||
      totalSalesData ||
      redeemedSummaryData ||
      topSellingProductData ||
      topRedeemingProductData
    );
  };
}
